/**
 * Brand/Vendor Filter — buttonsbebe.com
 * ---------------------------------------
 * DIFFERENT APPROACH from previous versions: instead of finding a real
 * Shopify checkbox and click-proxying to it (which depends on that checkbox
 * still existing and being interactive at click time — a dependency that
 * kept breaking in ways we couldn't fully pin down), this reads each real
 * checkbox's name/value ONCE on page load, computes the resulting filter
 * URL directly, and renders a plain <a href="..."> link.
 *
 * Clicking is then just a normal browser navigation — no JS involved in
 * the click itself, nothing to race against, nothing that can silently
 * fail partway through. Every filter click is a full page load, and this
 * script just needs to succeed once per page load to build its UI.
 */
(function () {
  'use strict';

  var TARGET_LABELS = ['Brand', 'Vendor'];
  var VISIBLE_COUNT = 8;

  function buildFilterURL(paramName, paramValue, makeActive) {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    var allValues = params.getAll(paramName);

    if (makeActive) {
      if (allValues.indexOf(paramValue) === -1) {
        params.append(paramName, paramValue);
      }
    } else {
      params.delete(paramName);
      allValues
        .filter(function (v) { return v !== paramValue; })
        .forEach(function (v) { params.append(paramName, v); });
    }
    return url.toString();
  }

  function buildFilter(widget) {
    var realList = widget.querySelector('ul.m-facets');
    if (!realList) return;

    var realCheckboxes = Array.prototype.slice.call(realList.querySelectorAll('input[type="checkbox"]'));
    if (!realCheckboxes.length) return;

    // Build everything in memory first (detached from the DOM), so we never
    // read geometry (getBoundingClientRect, offsetHeight, etc.) mid-rebuild —
    // that forces a synchronous reflow, confirmed via a Performance recording
    // to be one of several stacked forced reflows during this interaction.
    // Only touch the DOM once, right at the end, swapping old for new in one
    // pass instead of remove-then-build-then-insert.
    var existing = widget.querySelector('.bvf-wrap');

    var wrap = document.createElement('div');
    wrap.className = 'bvf-wrap';
    wrap.setAttribute('data-custom-filter-list', 'true');

    var searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.placeholder = 'Search...';
    searchInput.className = 'bvf-search';
    wrap.appendChild(searchInput);

    var list = document.createElement('div');
    list.className = 'bvf-list';
    wrap.appendChild(list);

    var items = [];

    realCheckboxes.forEach(function (cb) {
      var labelEl = cb.closest('.m-facet--checkbox');
      var textEl = labelEl ? labelEl.querySelector('.m-facet--label') : null;
      var labelText = textEl ? textEl.textContent.trim() : (labelEl ? labelEl.textContent.trim() : cb.value);

      var href = buildFilterURL(cb.name, cb.value, !cb.checked);

      var row = document.createElement('a');
      row.href = href;
      row.className = 'bvf-row' + (cb.checked ? ' bvf-row--checked' : '');
      if (cb.disabled) {
        row.classList.add('bvf-row--disabled');
        row.removeAttribute('href');
      }

      var box = document.createElement('span');
      box.className = 'bvf-box';

      var text = document.createElement('span');
      text.className = 'bvf-text';
      text.textContent = labelText;

      row.appendChild(box);
      row.appendChild(text);

      list.appendChild(row);
      items.push({ row: row, text: labelText.toLowerCase() });
    });

    var expanded = false;

    function updateVisibility() {
      var query = searchInput.value.toLowerCase().trim();
      items.forEach(function (item, idx) {
        var matchesSearch = query === '' || item.text.indexOf(query) !== -1;
        var withinLimit = query !== '' ? true : (expanded || idx < VISIBLE_COUNT);
        item.row.style.display = matchesSearch && withinLimit ? '' : 'none';
      });
    }

    searchInput.addEventListener('input', function (e) {
      e.stopPropagation(); // the theme's own filter form listens for ANY 'input' event bubbling up and treats it as a filter change — without this, every keystroke here triggers a full page reload
      updateVisibility();
    });

    realList.style.display = 'none';
    realList.insertAdjacentElement('afterend', wrap);
    if (existing) existing.remove();

    if (items.length > VISIBLE_COUNT) {
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'bvf-toggle';
      toggle.textContent = '+ Show More';
      toggle.addEventListener('click', function () {
        expanded = !expanded;
        toggle.textContent = expanded ? '- Show Less' : '+ Show More';
        list.classList.toggle('bvf-list--expanded', expanded);
        updateVisibility();
      });
      wrap.appendChild(toggle);
    }

    updateVisibility();

    widget.style.setProperty('--content-max-height', 'none');
    var realContent = widget.querySelector('.m-filter--widget-content');
    if (realContent) {
      realContent.classList.remove('m:overflow-hidden');
      realContent.style.overflow = 'visible';
    }
  }

  function init() {
    TARGET_LABELS.forEach(function (label) {
      var widget = document.querySelector('.m-filter--widget[data-filter-label="' + label + '" i]');
      if (widget) buildFilter(widget);
    });
  }

  // Register with the deterministic hook (assets/theme-hooks.js) instead of
  // guessing via MutationObserver — this runs every time the theme's own
  // Collection.init() runs, both on initial load and after every AJAX
  // filter update, with guaranteed correct timing.
  window.__customFilterRebuilders = window.__customFilterRebuilders || [];
  window.__customFilterRebuilders.push(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Single delayed retry for this script's OWN first attempt running before
  // checkboxes exist yet.
  setTimeout(init, 800);
})();